<div id="new">
  <a [routerLink]="urlBack" class="icn-arrow-left back">Voltar</a>

  <h1>{{ title }}</h1>
  <h2>{{ subtitle }}</h2>

  <ng-content></ng-content>
</div>
